import React from "react";
import { motion } from "framer-motion/dist/framer-motion";
import { bounce_right_to_left_variants_without_children } from "shared/components/animations";
const GuessedWord = ({ word, image }) => {
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={bounce_right_to_left_variants_without_children}
    >
      <div className="tw-title-card">
        <div className="text-center">
          <img src={image} className="mystry-word" alt="mystryWord" />
        </div>
        <div className="word-card">
          <h3 className="word">{word}</h3>
        </div>
      </div>
    </motion.div>
  );
};

export default GuessedWord;
